<template>
  <div class="access-denied">
    <div class="section">
      <img src="@designSystem/fondation/img/modal-warning.svg?url" />
      <BasicText size="h3">Accès refusé</BasicText>
      <BasicText size="h5">Vous n'avez pas les droits nécessaires pour accéder à cette page.</BasicText>
      <BasicText>
        Veuillez contacter votre administrateur du référentiel d'entreprise pour obtenir les permissions
        correspondantes.
      </BasicText>
      <BasicLink
        label="Retour à la page d'accueil"
        @link-click="routeAccueil"
      />
    </div>

    <div
      class="section"
      v-if="appState.estUtilisateurInterne"
    >
      <BasicLink
        label="Changer d'utilsateur externe pour accéder à la page"
        @link-click="changerUtilisateur"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
  import router from '@/router'
  import { useRoute } from 'vue-router'
  import { useAppStateStore } from '@/features/application'
  import { ROUTE_RESET_IMPERSO } from '@/features/auth/impersonnalisation'

  const route = useRoute()
  const appState = useAppStateStore()

  const changerUtilisateur = () => {
    router.replace({ name: ROUTE_RESET_IMPERSO, query: { to: route.query.to } })
  }

  const routeAccueil = () => {
    router.replace('/')
  }
</script>
<style lang="less" scoped>
  .access-denied {
    justify-self: center;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .section {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      margin: 12px 0;
      min-width: 260px;
      max-width: 60vw;
      padding: 28px;
      background-color: white;
      border-radius: 24px;

      img {
        min-width: 100px;
        max-width: 15vw;
        padding: 0 12px 24px 12px;
      }
    }
  }
</style>
